'use client'
import React from 'react'

import { CodeIcon } from '../../icons/Code/index.js'
import { LeafButton } from '../Button.js'

export const CodeLeafButton = () => (
  <LeafButton format="code">
    <CodeIcon />
  </LeafButton>
)
